export const getChartTemplatesState = state => state.chartTemplates;
